// extracted by mini-css-extract-plugin
export default {"ul":"youTubeVideoAddedEvent_ul__ip+KD","wrapper":"youTubeVideoAddedEvent_wrapper__gDADd"};